import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";
import hardware from "../../../assets/computer-hardware.jpg";
import software from "../../../assets/software.jpeg";
import office from "../../../assets/office.jpeg";
import network from "../../../assets/Network engineer.jpeg";
import linux from "../../../assets/linux.jpeg";
import dbms from "../../../assets/dbms.ly_3amt0uS";
import oop from "../../../assets/OOP.jpeg";
import web from "../../../assets/Web.jpeg";
import security from "../../../assets/security.jpeg";
import cloud from "../../../assets/cloud.jpeg";
import system from "../../../assets/Data Analysis.jpeg";
import adobe from "../../../assets/Adobe.jpeg";

const ITPrograms = [
  {
    id: 1,
    image: hardware,
    heading: "Computer Hardware",
    introduction:
      "Learn the fundamentals of computer hardware, components, and devices.",
    buttonText: "LEARN MORE",
    route: "computer-hardware",
  },
  {
    id: 2,
    image: software,
    heading: "Computer Software",
    introduction:
      "Understand software systems, operating systems, and essential programs.",
    buttonText: "LEARN MORE",
    route: "computer-software",
  },
  {
    id: 3,
    image: office,
    heading: "Computer Applications",
    introduction:
      "Gain practical skills in office tools and productivity applications.",
    buttonText: "LEARN MORE",
    route: "computer-applications",
  },
  {
    id: 4,
    image: network,
    heading: "Networking & System Administration",
    introduction:
      "Manage networks, servers, and IT infrastructure effectively.",
    buttonText: "LEARN MORE",
    route: "networking-system-administration",
  },
  {
    id: 5,
    image: linux,
    heading: "Linux Administration",
    introduction:
      "Specialized system administration for Linux-based environments.",
    buttonText: "LEARN MORE",
    route: "linux-administration",
  },
  {
    id: 6,
    image: dbms,
    heading: "Database Management",
    introduction:
      "Design, implement, and manage databases for applications and systems.",
    buttonText: "LEARN MORE",
    route: "database-management",
  },
  {
    id: 7,
    image: oop,
    heading: "Object-Oriented Programming (OOP)",
    introduction:
      "Master core programming concepts and object-oriented design principles.",
    buttonText: "LEARN MORE",
    route: "object-oriented-programming-oop",
  },
  {
    id: 8,
    image: web,
    heading: "Website & Application Development",
    introduction:
      "Build web and mobile applications using modern technologies.",
    buttonText: "LEARN MORE",
    route: "website-application-development",
  },
  {
    id: 9,
    image: security,
    heading: "Cyber Security",
    introduction: "Protect systems, networks, and data from cyber threats.",
    buttonText: "LEARN MORE",
    route: "cyber-security",
  },
  {
    id: 10,
    image: cloud,
    heading: "Cloud Computing",
    introduction:
      "Learn cloud infrastructure, deployment, and virtualization strategies.",
    buttonText: "LEARN MORE",
    route: "cloud-computing",
  },
  {
    id: 11,
    image: system,
    heading: "System Analysis & Design",
    introduction:
      "Plan and design IT systems efficiently for business and technical needs.",
    buttonText: "LEARN MORE",
    route: "system-analysis-design",
  },
  {
    id: 12,
    image: adobe,
    heading: "Adobe Applications",
    introduction:
      "Develop creative and design skills using Adobe multimedia tools.",
    buttonText: "LEARN MORE",
    route: "adobe-applications",
  },
];

const ITProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={ITPrograms}
        basePath="/courses/information-technology"
      />
    </div>
  );
};

export default ITProgramsCard;
